export default "__VITE_ASSET__9tURNv6r__"